import { api } from '@creditsights/api-ui-web';

const filterMapper = (array) => {
  if (array && array.length > 0) {
    return array.map((p) => ({ key: p.tagId, title: p.displayName, children: filterMapper(p.children) }));
  }
  return null;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const fetchFilters = async () => {
  const { data } = await api.get('common/v1/tags/filters');
  const resp = {};
  const map = {};

  for (const item of data) {
    for (const option of item.options) {
      map[option.tagId] = option.displayName;
    }

    resp[item.type] = filterMapper(item.options);
  }

  return {
    map,
    config: resp,
  };
};
